var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"fill-height d-flex justify-center",class:[
              { 'align-center' : !_vm.element.config.valign || _vm.element.config.valign === 'center'  },
              { 'align-baseline' :  _vm.element.config.valign === 'top'  },
              { 'align-end' :  _vm.element.config.valign === 'bottom'  }
          ],attrs:{"color":"transparent"}},[_c('v-divider',{style:(_vm.elementStyle),attrs:{"vertical":_vm.element.config.vertical}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }